<template>
  <div class="attached_files">
    <div class="">
      <label>Dữ liệu gốc</label>
    </div>
    <div class="file-upload row">
      <file-upload
        ref="uploadAttachFileRef"
        v-model="fileItems"
        class="col-md-12"
        button-class="btn-sm"
        :show-sync-dalet="false"
        :sync-dalet="false"
        :auto-upload="true"
        :remove-file-after-success="false"
        :close-modal-after-all-success="false"
        input-id="input-upload-attach-file"
        @click-file="onPreview"
      >
        <template #file-list="{ fileDataList }">
          <div
            v-if="fileDataList.length > 0"
            class="boxmedia mt-1"
          >
            <table class="table table-striped">
              <tbody>
                <tr
                  v-for="(item, index) in fileDataList"
                  :key="index"
                >
                  <td width="250">
                    <p
                      class="mb-0 lineText"
                      @click="onPreview(item)"
                    >
                      <strong>{{ item.filename_original }}</strong>
                    </p>
                    <p
                      v-if="item.error"
                      class="text-danger fs_9 font-weight mb-0"
                    >{{ item.error }}</p>
                    <div v-else>
                      <p
                        v-if="item.success || item.uploaded"
                        class="size fs_9 font-weight mb-0"
                      >
                        <span>{{ formatFileSize(item.size) }}</span>
                      </p>
                      <p
                        v-else
                        class="mb-0 size"
                      >{{ formatFileSize(item.progress * item.size / 100) }}/{{ $refs.uploadAttachFileRef.formatFileSize(item.size) }}</p>
                      <b-progress
                        v-if="!item.success && !item.uploaded"
                        max="100"
                        show-value
                        variant="success"
                        class="progress-bar-success"
                      >
                        <b-progress-bar
                          :value="item.progress"
                          :label="`${item.progress}%`"
                          variant="success"
                        />
                      </b-progress>
                    </div>
                    <!-- <div
                          v-if="item.success && item.uploaded"
                          class="badge badge-light-primary cursor-pointer d-inline-flex align-items-center"
                          @click.prevent="onUpdateContentEditor(item)"
                        >
                          <span class="icon_file_import" />Chèn vào bài
                        </div> -->
                  </td>
                  <td
                    class="text-right"
                    width="90"
                  >
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon btn-sm rounded-circle ml-1"
                    >
                      <span @click.prevent="confirmDeleteFileContent(item)">
                        <feather-icon icon="XIcon" />
                      </span>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </file-upload>
    </div>
  </div>
</template>

<script>
import {
  computed,
} from '@vue/composition-api';
import Ripple from 'vue-ripple-directive'
import { showToast } from '@/@core/utils/utils';
import {
  BProgress, BProgressBar, BButton,
} from 'bootstrap-vue'
import FileUpload from '@/views/files/components/FileUpload.vue';

export default {
  components: {
    FileUpload,
    BButton,
    BProgress,
    BProgressBar,
  },
  directives: {
    Ripple,
  },
  props: {
    topClass: {
      type: String,
      default: '',
    },
    attachedFiles: {
      type: Array,
      default: null,
    },

  },
  data() {
    return {

    }
  },
  computed: {
  },
  setup(props, context) {
    const fileItems = computed({
      get() {
        return props.attachedFiles
      },
      set(val) {
        context.emit('update-attached-files', val)
      },
    });

    return {
      fileItems,

    }
  },
  methods: {
    onUpdateContentEditor(item) {
      this.$emit('update-content-editor', item)
    },
    confirmDeleteFileContent(file) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$refs.uploadAttachFileRef.deleteUploadFile(file)
        }
      })
    },
    onPreview(item) {
      if (item.success && item.uploaded) {
        this.$emit('preview', item)
      } else {
        showToast('File chưa upload')
      }
    },
    formatFileSize(bytes, decimals) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },

  },
}
</script>

<style lang="scss" scoped></style>
